module.exports = __webpack_public_path__ + "static/img/sc02.1e2fbd15.png";